import { render, staticRenderFns } from "./indexset.vue?vue&type=template&id=8a2e2f64&scoped=true&"
import script from "./indexset.vue?vue&type=script&lang=js&"
export * from "./indexset.vue?vue&type=script&lang=js&"
import style0 from "./indexset.vue?vue&type=style&index=0&id=8a2e2f64&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2e2f64",
  null
  
)

export default component.exports